import * as React from 'react';
import { Form } from 'react-bootstrap';
import Date from '../form/Date';

export default function TrademarkStep1({
  state,
  onChange,
  validated,
  imageLogoSrc,
  allowedExtensions,
}) {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        <div className="polaroid">
          <p className="primary-label">Select what you are trying to protect</p>

          <div key={`inline-radio`} className="mb-3">
            <Form.Check
              inline
              label="Name"
              name="trademarkType"
              type="radio"
              id="type1"
              value={'NAME'}
              checked={state.trademarkType === 'NAME'}
              onChange={handleChange}
            />
            <Form.Check
              inline
              label="Slogan"
              name="trademarkType"
              id="type2"
              type="radio"
              value={'SLOGAN'}
              checked={state.trademarkType === 'SLOGAN'}
              onChange={handleChange}
            />
            <Form.Check
              inline
              label="Logo"
              name="trademarkType"
              id="type3"
              type="radio"
              value={'LOGO'}
              checked={state.trademarkType === 'LOGO'}
              onChange={handleChange}
            />
          </div>
          {state.trademarkType === 'NAME' ? (
            <>
              <Form.Group className="mb-3" controlId="markDesc">
                <Form.Label required>the name you wish to protect</Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter the name you wish to protect"
                  onChange={handleChange}
                  data-hj-allow
                  value={state.markDesc ? state.markDesc : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid name
                </Form.Control.Feedback>
              </Form.Group>{' '}
            </>
          ) : null}
          {state.trademarkType === 'SLOGAN' ? (
            <>
              <Form.Group className="mb-3" controlId="markDesc">
                <Form.Label required>
                  Enter the slogan you wish to protect
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter the slogan you wish to protect"
                  onChange={handleChange}
                  data-hj-allow
                  value={state.markDesc ? state.markDesc : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid slogan
                </Form.Control.Feedback>
              </Form.Group>
            </>
          ) : null}
          {state.trademarkType === 'LOGO' ? (
            <>
              <Form.Group className="mb-3" controlId="literalElements">
                <Form.Label required>
                  Please provide a complete and accurate description of your
                  logo, including any words that may appear in the logo. An
                  example of a description is: ‘a red cat wrapped around a blue
                  outline of a globe’. Leave out the colors if you want to
                  protect your logo in all colors
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder=""
                  onChange={handleChange}
                  data-hj-allow
                  value={state.literalElements ? state.literalElements : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a complete and accurate description of your
                  logo
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="logoColoredVariety">
                <Form.Label>
                  Do you want to be able to protect your logo in a variety of
                  colors?
                </Form.Label>
                <br />
                <Form.Check
                  inline
                  label="Yes"
                  name="logoColoredVariety"
                  type="radio"
                  value={'true'}
                  checked={state.logoColoredVariety === 'true'}
                  onChange={handleChange}
                  id={`logoColoredVariety1`}
                />
                <Form.Check
                  inline
                  label="No"
                  name="logoColoredVariety"
                  type="radio"
                  value={'false'}
                  checked={state.logoColoredVariety === 'false'}
                  onChange={handleChange}
                  id={`logoColoredVariety2`}
                />
              </Form.Group>
              {state.logoColoredVariety === 'false' ? (
                <Form.Group
                  className="mb-3"
                  controlId="colorsInLogo"
                  style={{ marginLeft: '2em' }}
                >
                  <Form.Label required>
                    Please provide a list of the colors that appear in your
                    logo.
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder=""
                    onChange={handleChange}
                    data-hj-allow
                    value={state.colorsInLogo ? state.colorsInLogo : ''}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a list of the colors that appear in your
                    logo.
                  </Form.Control.Feedback>
                </Form.Group>
              ) : (
                <p style={{ color: '#03589C', fontWeight: '600' }}>
                  To protect your logo in a variety of colors, your uploaded
                  logo file must be black on a white background (no grey scale,
                  a TRUE black and white image).
                </p>
              )}
              <Form.Group className="mb-3" controlId="markDesc">
                <Form.Label required>
                  Enter any word(s), letter(s), and/or number(s) that appear in
                  your logo.
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder=""
                  onChange={handleChange}
                  data-hj-allow
                  value={state.markDesc ? state.markDesc : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a complete and accurate description of your
                  logo
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formLogoFile" className="mb-3">
                <Form.Label>Upload logo file</Form.Label>
                <Form.Control
                  type="file"
                  required={imageLogoSrc ? false : true}
                  accept={allowedExtensions}
                  style={{ height: '100%' }}
                  onChange={handleChange}
                  isInvalid={state.isFileInvalidSize.length > 0}
                />
                <Form.Control.Feedback type="invalid">
                  {state.isFileInvalidSize.length > 0
                    ? state.isFileInvalidSize
                    : 'Please select file'}
                </Form.Control.Feedback>
              </Form.Group>
              {imageLogoSrc && (
                <img
                  style={{ width: '400px', maxWidth: '100%' }}
                  src={imageLogoSrc}
                />
              )}
            </>
          ) : null}
        </div>
        <div className="polaroid">
          <Form.Group controlId="isIncludeLivingPersonName" className="mb-3">
            <Form.Label className="primary-label">
              Does your mark include a living person’s name—even if a stage name
              or pseudonym or could it be perceived to include a person’s name?
            </Form.Label>
            <br />
            <Form.Check
              inline
              label="Yes"
              name="isIncludeLivingPersonName"
              type="radio"
              value={'true'}
              checked={state.isIncludeLivingPersonName === 'true'}
              onChange={handleChange}
              id={`isIncludeLivingPersonName2`}
            />
            <Form.Check
              inline
              label="No"
              name="isIncludeLivingPersonName"
              type="radio"
              value={'false'}
              checked={state.isIncludeLivingPersonName === 'false'}
              onChange={handleChange}
              id={`isIncludeLivingPersonName1`}
            />
          </Form.Group>
          {state.isIncludeLivingPersonName === 'true' ? (
            <>
              <Form.Group
                controlId="isIncludeNicknameName"
                className="mb-3"
                style={{ marginLeft: '2em' }}
              >
                <Form.Label>
                  Does your mark include a name (including a pseudonym, nickname
                  or stage name) that is yours?
                </Form.Label>
                <br />
                <Form.Check
                  inline
                  label="Yes"
                  name="isIncludeNicknameName"
                  type="radio"
                  value={'true'}
                  checked={state.isIncludeNicknameName === 'true'}
                  onChange={handleChange}
                  id={`isIncludeNicknameName2`}
                />
                <Form.Check
                  inline
                  label="No"
                  name="isIncludeNicknameName"
                  type="radio"
                  value={'false'}
                  checked={state.isIncludeNicknameName === 'false'}
                  onChange={handleChange}
                  id={`isIncludeNicknameName1`}
                />
              </Form.Group>
              {state.isIncludeNicknameName === 'false' ? (
                <>
                  <Form.Group
                    controlId="isOtherLivingName"
                    className="mb-3"
                    style={{ marginLeft: '2em' }}
                  >
                    <Form.Label>
                      Does your mark include the name (including a pseudonym,
                      nickname or stage name) of a living person other than
                      yourself?
                    </Form.Label>
                    <br />
                    <Form.Check
                      inline
                      label="Yes"
                      name="isOtherLivingName"
                      type="radio"
                      value={'true'}
                      checked={state.isOtherLivingName === 'true'}
                      onChange={handleChange}
                      id={`isOtherLivingName2`}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="isOtherLivingName"
                      type="radio"
                      value={'false'}
                      checked={state.isOtherLivingName === 'false'}
                      onChange={handleChange}
                      id={`isOtherLivingName1`}
                    />
                  </Form.Group>
                  {state.isOtherLivingName === 'true' ? (
                    <Form.Group
                      className="mb-3"
                      controlId="ownName"
                      style={{ marginLeft: '2em' }}
                    >
                      <Form.Label required>
                        What is the name of the living person in your mark?
                      </Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="What is the name of the living person in your mark?"
                        onChange={handleChange}
                        data-hj-allow
                        value={state.ownName ? state.ownName : ''}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide a valid name
                      </Form.Control.Feedback>
                    </Form.Group>
                  ) : null}
                </>
              ) : (
                <Form.Group
                  className="mb-3"
                  controlId="ownName"
                  style={{ marginLeft: '2em' }}
                >
                  <Form.Label required>
                    Please type the legal name to whom the mark references.
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder="Please type the legal name to whom the mark references."
                    onChange={handleChange}
                    data-hj-allow
                    value={state.ownName ? state.ownName : ''}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid name
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            </>
          ) : null}
        </div>
      </div>

      <div className="question">
        <div className="polaroid">
          <Form.Group controlId="includeTranslationWords" className="mb-3">
            <Form.Label className="primary-label">
              Does your mark include any words other than English or non-Latin
              characters?
            </Form.Label>
            <br />
            <Form.Check
              inline
              label="Yes"
              name="includeTranslationWords"
              type="radio"
              value={'true'}
              checked={state.includeTranslationWords === 'true'}
              onChange={handleChange}
              id={`includeTranslationWords1`}
            />
            <Form.Check
              inline
              label="No"
              name="includeTranslationWords"
              type="radio"
              value={'false'}
              checked={state.includeTranslationWords === 'false'}
              onChange={handleChange}
              id={`includeTranslationWords2`}
            />
          </Form.Group>
          {state.includeTranslationWords === 'true' ? (
            <>
              <Form.Group
                className="mb-3"
                controlId="translation"
                style={{ marginLeft: '2em' }}
              >
                <Form.Label required>
                  Please provide the English translation or transliteration of
                  any non-Latin characters or non-English words:
                </Form.Label>

                <Form.Control
                  type="text"
                  required
                  placeholder="Please provide the English translation"
                  onChange={handleChange}
                  data-hj-allow
                  value={state.translation ? state.translation : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide the English translation
                </Form.Control.Feedback>
              </Form.Group>{' '}
            </>
          ) : null}
        </div>
        <div className="polaroid">
          <Form.Group controlId="currentTrademark" className="mb-3">
            <Form.Label className="primary-label">
              Are you currently using this trademark in your business?
            </Form.Label>
            <br />
            <Form.Check
              inline
              label="Yes"
              name="currentTrademark"
              type="radio"
              value={'true'}
              checked={state.currentTrademark === 'true'}
              onChange={handleChange}
              id={`currentTrademark1`}
            />
            <Form.Check
              inline
              label="No"
              name="currentTrademark"
              type="radio"
              value={'false'}
              checked={state.currentTrademark === 'false'}
              onChange={handleChange}
              id={`currentTrademark2`}
            />
          </Form.Group>
          {state.currentTrademark === 'true' ? (
            <div style={{ marginLeft: '2em' }}>
              <Date
                id="firstUseAnywhere"
                label="1. First use anywhere:"
                day={state.firstUseAnywhereDay}
                month={state.firstUseAnywhereMonth}
                required={true}
                year={state.firstUseAnywhereYear}
                onChange={handleChange}
              />
              <Date
                id="firstUseInCommerce"
                label="2. First use in commerce:"
                day={state.firstUseInCommerceDay}
                month={state.firstUseInCommerceMonth}
                required={true}
                year={state.firstUseInCommerceYear}
                onChange={handleChange}
              />
            </div>
          ) : (
            <Form.Text className="text-muted">
              If you do not have proof now, you can submit proof later after
              your trademark is submitted to the Trademark office. If you do it
              later, you will need to pay a $150 government fee (for US
              trademarks).
            </Form.Text>
          )}
        </div>
      </div>
    </Form>
  );
}
